import React, { useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { ArrowRight, User, Tag } from "lucide-react";
import { blogs } from "./blogData";
import { Helmet } from "react-helmet";

// Import only existing blog content files
import customerCentricMindsetContent from "./content/customer-centric-mindset-the-catalyst-for-enhancing-customer-lifetime-value";
import dataStorytellingContent from "./content/data-storytelling";
import marketingKpiBeaconsContent from "./content/marketing-kpi-beacons";
import winBackLostCustomersContent from "./content/win-back-lost-customers";
import generationalMarketingContent from "./content/generational-marketing-strategies";
import frictionlessOrMemorablecxContent from "./content/frictionless-or-memorable-cx";
import makeRepeatPurchasesContent from "./content/make-repeat-purchases-a-new-customer-habit";
import revitalizeYourCustomerBaseContent from "./content/revitalize-your-customer-base";
import martechProfessionalsContent from "./content/martech-professionals";
import orthogonalStrategiesContent from "./content/orthogonal-strategies";
import futureProofingContent from "./content/future-proofing-marketing-strategy";
import winningBackLostContent from "./content/winning-back-lost-customers";
import craftingMagneticContent from "./content/crafting-magnetic-connections";
import powerBiRetailContent from "./content/power-bi-retail";
import seizeTheFutureContent from "./content/seize-the-future-genai";
import behavioralAnalyticsContent from "./content/behavioral-analytics";
import navigationMarketingContent from "./content/navigation-marketing-chaos";
import readingBetweenClicksContent from "./content/reading-between-clicks";
import decoyDynamicsContent from "./content/decoy-dynamics";
import extractingWisdomContent from "./content/extracting-wisdom";
import digitalTwinContent from "./content/digital-twin-revolution";
import hoursToScaleEcommerceContent from "./content/how-to-scale-and-grow-your-e-commerce-business-with-data-engineering";
import kpiLibraryContent from "./content/is-it-worth-investing-in-a-readymade-library-of-key-performance-indicators-to-gauge-business-performance";
import powerOfSegmentsContent from "./content/power-of-data-driven-segments-in-the-footwear-industry";
import identityResolutionContent from "./content/identity-resolution-your-north-star-for-customer-contentment";
import alchemyDigitalContent from "./content/alchemy-in-the-digital-era-for-sculpting-tomorrows-businesses";
import secretsDeliverContent from "./content/secrets-to-delivering-an-immersive-customer-experience-in-the-sports-industry";
import inTheMomentContent from "./content/in-the-moment-experience-in-phygital-world";
import gameChangingRetailContent from "./content/game-changing-innovations-in-retail-cx";
import whyConsolidatingContent from "./content/why-consolidating-traditional-and-digital-commerce-is-crucial-to-omnichannel-agility-and-viability-for-marketers";
import topHacksContent from "./content/top-hacks-to-hook-customers-and-foster-brand-loyalty";
import sustainingParadoxContent from "./content/sustaining-the-paradox-of-alternatives-the-dire-trend-in-customer-behaviour";
import martechCampaignsContent from "./content/strategizing-and-building-scalable-martech-campaigns";
import emailMarketingContent from "./content/no-more-open-rate-as-an-email-marketing-kpi";
import cookielessWorldContent from "./content/life-in-a-cookie-less-world";
import integratedExperienceContent from "./content/integrated-experience-ix-is-the-future-of-customer-experience-cx";
import biDashboardContent from "./content/bi-dashboard-design-principles-and-best-practices";
import biggestDataScienceContent from "./content/biggest-data-science-challenges-of-2023-and-how-to-overcome-them";
import dataDocumentationContent from "./content/the-cost-of-poor-quality-data";
import marketingAutomationSkillsetContent from "./content/the-marketing-automation-skillset";
import digitalEcosystemsContent from "./content/how-digital-ecosystems-are-reshaping-businesses";
import selfServiceBiContent from "./content/how-self-service-bi-capabilities-improve-harnessing-insights-from-massive-data";
import marketingAutomationContent from "./content/8-reasons-why-marketing-automation-is-the-new-career";
import predictiveAnalyticsContent from "./content/demystifying-predictive-analytics";
import customerExperienceContent from "./content/take-your-customers-experience-to-the-next-level-with-predictive-analytics";
import ecommerceSuccessContent from "./content/5-key-factors-to-consider-for-e-commerce-success";
import embracingFailureContent from "./content/embracing-failure-to-becoming-successful";
import marketingCustomerContent from "./content/is-your-marketing-and-customer-on-same-page";
import developingLeadersContent from "./content/developing-the-nextgen-leaders-in-our-unique-way";
import entrepreneurshipContent from "./content/entrepreneurship-development-program";
import expressPreparationContent from "./content/express-preparation-for-pl-300-microsoft-power-bi-data-analyst";
import significanceDataAnalysisContent from "./content/significance-of-data-analysis-and-its-impact-on-the-conversion-rates";
import aiToPredictContent from "./content/ai-to-predict-interactivity-in-campaigns";
import keySkillsContent from "./content/key-skills-for-marketing-automation-team";
import pulseEngagementContent from "./content/the-pulse-of-customer-engagement";
import ibmBeaconContent from "./content/ibm-beacon-award-finalist-2021";
import dataDemocratisationContent from "./content/importance-of-data-democratisation-for-marketing-success";
import howRetailCMOsCanOvercomeTheirBiggestChallengesWithAICopilots from "./content/how-retail-cmos-can-overcome-their-biggest-challenges-with-ai-copilots";
import buildApplications3xFasterwithAIPoweredProjectIntelligence from "./content/build-applications-3x-faster-with-ai-powered-project-intelligence";
import whyMartechFailsandHowtoWinin2026 from "./content/why-martech-fails-and-how-to-win-2026";
import salesforceImplementationServicesInIndiaContent from "./content/salesforce-implementation-services-in-india";
import salesforceAgentforceUseCasesContent from "./content/salesforce-agentforce-use-cases";
import salesforceMarketingCloudContent from "./content/salesforce-marketing-cloud";
import headlessCrmContent from "./content/headless-crm";
import howComsenseHelpsTeamsGetMoreValueFromSlack from "./content/how-comsense-helps-teams-get-more-value-from-slack";
import globalCapabilityCentersNeedAReset from "./content/global-capability-centers-need-a-reset";
import whyTheNextGccWillBeJudgedOnValueNotJustCostContent from "./content/why-the-next-gcc-will-be-judged-on-value-not-just-cost";
import b2bCustomerDataPlatformBestPracticesContent from "./content/b2b-customer-data-platform-best-practices";
import salesforceMarketingCloudMigrationServicesContent from "./content/salesforce-marketing-cloud-migration-services-what-businesses-need-to-know-before-making-the-switch";
import whyRetailersAreRethinkingCustomerExperienceInTheAiEraContent from "./content/why-retailers-are-rethinking-customer-experience-in-the-ai-era";
import howComsenseCombatsSalesforceMarketingCloudMigrationChallengesContent from "./content/how-comsense-combats-key-challenges-that-businesses-face-during-salesforce-marketing-cloud-migration";
import thePersonalizationPlaybookIsChangingContent from "./content/the-personalization-playbook-is-changing-is-your-business-ready";
import howToMaximizeSalesforceMarketingCloudRoiContent from "./content/how-to-maximize-salesforce-marketing-cloud-roi";

const slugify = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const BlogDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const blog = blogs.find(
    (item) =>
      item.slug === slug ||
      slugify(item.title) === slug ||
      String(item.id) === slug,
  );

  useEffect(() => {
    if (blog && String(blog.id) === slug) {
      // Redirect old numeric URL to slug URL
      navigate(`/blog/${blog.slug || slugify(blog.title)}`, { replace: true });
    }
  }, [blog, slug, navigate]);

  if (!blog) {
    return (
      <Container className="py-5">
        <div className="text-center">
          <h2>Blog not found</h2>
          <p>
            The article you are looking for does not exist or has been moved.
          </p>
          <Link to="/blog" className="btn btn-dark">
            Back to all blogs
          </Link>
        </div>
      </Container>
    );
  }

  // Create full content by slug mapping
  const fullContentBySlug = {
    "customer-centric-mindset-the-catalyst-for-enhancing-customer-lifetime-value":
      customerCentricMindsetContent,
    "data-storytelling": dataStorytellingContent,
    "lighting-the-way-with-marketing-kpi-beacons": marketingKpiBeaconsContent,
    "win-back-lost-customers": winBackLostCustomersContent,
    "generational-marketing-strategies": generationalMarketingContent,
    "frictionless-or-memorable-cx": frictionlessOrMemorablecxContent,
    "make-repeat-purchases-a-new-customer-habit": makeRepeatPurchasesContent,
    "revitalize-your-customer-base": revitalizeYourCustomerBaseContent,
    "martech-professionals": martechProfessionalsContent,
    "orthogonal-strategies": orthogonalStrategiesContent,
    "future-proofing-marketing-strategy": futureProofingContent,
    "winning-back-lost-customers": winningBackLostContent,
    "crafting-magnetic-connections": craftingMagneticContent,
    "power-bi-retail": powerBiRetailContent,
    "seize-the-future-genai": seizeTheFutureContent,
    "behavioral-analytics": behavioralAnalyticsContent,
    "navigation-marketing-chaos": navigationMarketingContent,
    "reading-between-clicks": readingBetweenClicksContent,
    "decoy-dynamics": decoyDynamicsContent,
    "extracting-wisdom": extractingWisdomContent,
    "digital-twin-revolution": digitalTwinContent,
    "the-digital-twin-revolution": digitalTwinContent,
    "how-to-scale-and-grow-your-e-commerce-business-with-data-engineering":
      hoursToScaleEcommerceContent,
    "is-it-worth-investing-in-a-readymade-library-of-key-performance-indicators-to-gauge-business-performance":
      kpiLibraryContent,
    "power-of-data-driven-segments-in-the-footwear-industry":
      powerOfSegmentsContent,
    "identity-resolution-your-north-star-for-customer-contentment":
      identityResolutionContent,
    "alchemy-in-the-digital-era-for-sculpting-tomorrows-businesses":
      alchemyDigitalContent,
    "secrets-to-delivering-an-immersive-customer-experience-in-the-sports-industry":
      secretsDeliverContent,
    "in-the-moment-experience-in-phygital-world": inTheMomentContent,
    "game-changing-innovations-in-retail-cx": gameChangingRetailContent,
    "why-consolidating-traditional-and-digital-commerce-is-crucial-to-omnichannel-agility-and-viability-for-marketers":
      whyConsolidatingContent,
    "top-hacks-to-hook-customers-and-foster-brand-loyalty": topHacksContent,
    "sustaining-the-paradox-of-alternatives-the-dire-trend-in-customer-behaviour":
      sustainingParadoxContent,
    "strategizing-and-building-scalable-martech-campaigns":
      martechCampaignsContent,
    "no-more-open-rate-as-an-email-marketing-kpi": emailMarketingContent,
    "life-in-a-cookie-less-world": cookielessWorldContent,
    "integrated-experience-ix-is-the-future-of-customer-experience-cx":
      integratedExperienceContent,
    "bi-dashboard-design-principles-and-best-practices": biDashboardContent,
    "biggest-data-science-challenges-of-2023-and-how-to-overcome-them":
      biggestDataScienceContent,
    "the-cost-of-poor-quality-data": dataDocumentationContent,
    "the-marketing-automation-skillset": marketingAutomationSkillsetContent,
    "how-digital-ecosystems-are-reshaping-businesses": digitalEcosystemsContent,
    "how-self-service-bi-capabilities-improve-harnessing-insights-from-massive-data":
      selfServiceBiContent,
    "8-reasons-why-marketing-automation-is-the-new-career":
      marketingAutomationContent,
    "demystifying-predictive-analytics": predictiveAnalyticsContent,
    "take-your-customers-experience-to-the-next-level-with-predictive-analytics":
      customerExperienceContent,
    "5-key-factors-to-consider-for-e-commerce-success": ecommerceSuccessContent,
    "embracing-failure-to-becoming-successful": embracingFailureContent,
    "is-your-marketing-and-customer-on-same-page": marketingCustomerContent,
    "developing-the-nextgen-leaders-in-our-unique-way":
      developingLeadersContent,
    "entrepreneurship-development-program": entrepreneurshipContent,
    "express-preparation-for-pl-300-microsoft-power-bi-data-analyst":
      expressPreparationContent,
    "significance-of-data-analysis-and-its-impact-on-the-conversion-rates":
      significanceDataAnalysisContent,
    "ai-to-predict-interactivity-in-campaigns": aiToPredictContent,
    "key-skills-for-marketing-automation-team": keySkillsContent,
    "the-pulse-of-customer-engagement": pulseEngagementContent,
    "ibm-beacon-award-finalist-2021": ibmBeaconContent,
    "importance-of-data-democratisation-for-marketing-success":
      dataDemocratisationContent,
    "how-retail-cmos-can-overcome-their-biggest-challenges-with-ai-copilots":
      howRetailCMOsCanOvercomeTheirBiggestChallengesWithAICopilots,
    "build-applications-3x-faster-with-ai-powered-project-intelligence":
      buildApplications3xFasterwithAIPoweredProjectIntelligence,
    "why-martech-fails-and-how-to-win-2026": whyMartechFailsandHowtoWinin2026,
    "salesforce-implementation-services-in-india":
      salesforceImplementationServicesInIndiaContent,
    "salesforce-agentforce-use-cases":
      salesforceAgentforceUseCasesContent,
    "salesforce-marketing-cloud":
      salesforceMarketingCloudContent,
    "headless-crm": headlessCrmContent,
    "how-comsense-helps-teams-get-more-value-from-slack": howComsenseHelpsTeamsGetMoreValueFromSlack,
    "global-capability-centers-need-a-reset": globalCapabilityCentersNeedAReset,
    "why-the-next-gcc-will-be-judged-on-value-not-just-cost":
      whyTheNextGccWillBeJudgedOnValueNotJustCostContent,
    "b2b-customer-data-platform-best-practices":
      b2bCustomerDataPlatformBestPracticesContent,
    "salesforce-marketing-cloud-migration-services-what-businesses-need-to-know-before-making-the-switch":
      salesforceMarketingCloudMigrationServicesContent,
    "why-retailers-are-rethinking-customer-experience-in-the-ai-era":
      whyRetailersAreRethinkingCustomerExperienceInTheAiEraContent,
    "how-comsense-combats-key-challenges-that-businesses-face-during-salesforce-marketing-cloud-migration":
      howComsenseCombatsSalesforceMarketingCloudMigrationChallengesContent,
    "the-personalization-playbook-is-changing-is-your-business-ready":
      thePersonalizationPlaybookIsChangingContent,
    "how-to-maximize-salesforce-marketing-cloud-roi":
      howToMaximizeSalesforceMarketingCloudRoiContent,
  };


  const blogSlug = blog.slug || slugify(blog.title);
  const content = fullContentBySlug[blogSlug] || [
    blog.excerpt,
    `${blog.excerpt} More detail on this topic will be available soon...`,
    "Thank you for reading. Stay tuned for more updates from Comsense.",
  ];

  return (
    <>
      <Helmet>
        <title>{blog.metaTitle || blog.title} | Comsense Blog</title>
        <meta
          name="description"
          content={blog.metaDescription || blog.excerpt || "Read our latest blog post on " + blog.title}
        />
        {blog.metaKeywords && (
          <meta name="keywords" content={blog.metaKeywords} />
        )}
        <meta property="og:title" content={blog.metaTitle || blog.title} />
        <meta
          property="og:description"
          content={blog.metaDescription || blog.excerpt}
        />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={blog.image} />
      </Helmet>
      <style>{`
        .blog-details { font-family: 'Outfit', sans-serif; background: #fff; color: #0f172a; }
        .blog-details-hero { position: relative; padding: 100px 0 80px; background: #ffffff; border-bottom: 1px solid #e2e8f0; }
        .details-header { margin-bottom: 25px; }
        .details-meta { color: #64748b; font-size: 14px; margin-bottom: 16px; display: flex; flex-wrap: wrap; align-items: center; gap: 12px; }
        .details-meta span { display: inline-flex; align-items: center; gap: 6px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; }
        .details-title { font-size: clamp(2rem, 5vw, 2.75rem); font-weight: 800; line-height: 1.18; margin-bottom: 15px; color: #0f172a; 
        font-weight: 800;
  font-size: 42px;
  letter-spacing: -0.02rem;
        }
        .details-subtitle { color: #475569; font-size: 1.1rem; max-width: 780px; margin-bottom: 0; }
        .details-card { background: #ffffff; border: 0; border-radius: 20px; box-shadow: 0 20px 40px rgba(15, 23, 42, 0.1); overflow: hidden; }
        .details-image { width: 100%; 
        // max-height: 520px; object-fit: cover; 
        display: block; }
        .details-article { padding: 2rem 2.5rem 2.5rem; }
        .details-content p { 
        // margin-bottom: 24px; 
        font-size: 15px; 
        // line-height: 1.75; 
        color: #334155; 
        }
        .details-content h2 { font-size: 1.55rem; font-weight: 700; margin-top: 2rem; margin-bottom: 1rem; color: #0f172a; }
        .details-list { margin-left: 0rem; margin-bottom: 1.5rem; list-style: disc; color: #334155; }
        .details-list li { margin-bottom: 0.3rem; font-size: 15px; line-height: 1.75; }
        .details-cta { margin-top: 1.6rem; }
        .details-cta a { display: inline-block; text-decoration: none; background: #0f172a; color: #fff; padding: 10px 18px; border-radius: 10px; font-weight: 700; transition: all 0.25s ease; }
        .details-cta a:hover { background: #334155; }
        .back-link { 
        text-decoration: none; padding: 11px 18px; border-radius: 10px; transition: all 0.25s ease; display: inline-flex; align-items: center; gap: 6px;
        
  background: #ee0000;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 10px 18px;
  font-weight: 700;
  box-shadow: 0 12px 24px rgba(238,0,0,0.18);

        }
        .back-link:hover { background: #cf0707; color: #ffffff; border-color: #0f172a; }
        .btn-blog { border-radius: 10px; background: #0f172a; color: #ffffff; font-weight: 700; border: none; padding: 12px 20px; }
        @media (max-width: 768px) {
          .blog-details-hero { padding: 70px 0 50px; }
          .details-article { padding: 1.4rem 1.2rem 1.8rem; }
        }

        .blog-details-hero {
  position: relative;
  overflow: hidden;
  background:#effdff;
}
//   .blog-details-hero::before {
//   content: "";
//   position: absolute;
//   top: -80px;
//   left: -80px;
//   width: 250px;
//   height: 250px;
//   background: #a6dbf4;
// opacity: 0.1;  border-radius: 50%;
// }

// .blog-details-hero::after {
//   content: "";
//   position: absolute;
//   bottom: -100px;
//   right: -100px;
//   width: 300px;
//   height: 300px;
//   background: #a6dbf4;
//   opacity: 0.1;
//   border-radius: 50%;
// }
  .details-header {
  position: relative;
  z-index: 2;
}
  .details-content h2 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-top: 2rem;
  color: #0f172a;
}

.details-content h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 1.5rem;
  color: #1e293b;
}
      `}</style>
      <div className="blog-details">
        <section className="blog-details-hero">
          <Container>
            <div className="details-header text-start">
              <div className="details-meta">
                <span>
                  <Tag size={14} /> {blog.category}
                </span>
                {/* <span>
                  <Calendar size={14} /> {blog.date}
                </span> */}
                <span>
                  <User size={14} /> {blog.author}
                </span>
              </div>
              <h1 className="details-title">{blog.title}</h1>
              <p className="details-subtitle">{blog.excerpt}</p>
            </div>
          </Container>
        </section>

        <Container className="py-5">
          <div className="details-card">
            <img src={blog.image} alt={blog.title} className="details-image" />
            <div className="details-article">
              <div className="details-content">
                {content.map((block, idx) => {
                  if (block.type === "heading") {
                    // return <h2 key={idx}>{block.text}</h2>;
                    const HeadingTag = `h${block.level || 2}`;
                    if (
                      typeof block.text === "string" &&
                      block.text.includes("<")
                    ) {
                      return (
                        <HeadingTag
                          key={idx}
                          dangerouslySetInnerHTML={{ __html: block.text }}
                        />
                      );
                    }
                    return <HeadingTag key={idx}>{block.text}</HeadingTag>;
                  }

                  if (block.type === "list") {
                    return (
                      <ul key={idx} className="details-list">
                        {block.items.map((item, itemIdx) => (
                          <li
                            key={itemIdx}
                            dangerouslySetInnerHTML={{ __html: item }}
                          />
                        ))}
                      </ul>
                    );
                  }

                  if (block.type === "cta") {
                    return (
                      <div key={idx} className="details-cta">
                        <Link to={block.url}>{block.text}</Link>
                      </div>
                    );
                  }

                  return (
                    <p
                      key={idx}
                      dangerouslySetInnerHTML={{ __html: block.text }}
                    />
                  );
                })}
              </div>
              <div className="mt-5">
                <Link to="/blog" className="back-link">
                  <ArrowRight size={14} /> Back to Blogs
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default BlogDetails;
